import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { TManagementTabs } from 'models/management.models'
import { MANAGEMENT_TABS } from 'lib/enums/management.enums'
import { IManagementState } from './management.models'

const initialState: IManagementState = {
  activeTab: MANAGEMENT_TABS.WORKSPACES,
}

const managementSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setManagementActiveTab(state, action: PayloadAction<TManagementTabs>) {
      state.activeTab = action.payload
    },
  },
})

export const { setManagementActiveTab } = managementSlice.actions

export default managementSlice.reducer
